import { Theme } from '@mui/material/styles'
import { Maps, MapOptions } from 'google-map-react'

/**
 * Generate Options for google map
 */
export const createMapOptions = (maps: Maps, theme: Theme): Partial<MapOptions> => {
  return {
    zoomControlOptions: {
      position: maps.ControlPosition.TOP_LEFT,
    },
    gestureHandling: 'cooperative',
    styles: [
      {
        featureType: 'all',
        elementType: 'labels.text',
        stylers: [
          {
            color: theme.palette.grey.grey02,
          },
        ],
      },
      {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          {
            color: theme.palette.shades.shade04,
          },
        ],
      },
      {
        featureType: 'poi',
        stylers: [
          {
            color: theme.palette.primary.light,
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text',
        stylers: [
          {
            color: theme.palette.primary.main,
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#c9c9c9',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'all',
        stylers: [
          {
            color: '#B6E8EE',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [
          {
            color: '#B6E8EE',
          },
        ],
      },
    ],
  }
}
